import { PreferencesFormData } from '@app/shared/types/preferences/preferences.type';
import {
  DEFAULT_DECIMAL_DIVIDER,
  DEFAULT_NUMBER_PRECISION,
  DEFAULT_THOUSANDS_DIVIDER,
} from './global-constants';

export const COMPANY_PREFERENCES_DEFAULTS: PreferencesFormData = {
  common: {
    money_precision: 2,
    rounding_strategy: 'roundup',
    currency: {
      code: 'USD',
      sign: '$',
    },
  },
  regional_settings: {
    decimal_separator: DEFAULT_DECIMAL_DIVIDER,
    precision: DEFAULT_NUMBER_PRECISION,
    thousands_separator: DEFAULT_THOUSANDS_DIVIDER,
  },
};
